import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgModel } from '@angular/forms';
import { startWith } from 'rxjs';
import { InputControlBase } from '../forms/input-control.base';

/*
Uses datetime-local so support for FF and safari isn't complete see
https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input/datetime-local#browser_compatibility
*/

@Component({
    selector: 'app-date-time-picker',
    template: `
    <mat-form-field class="w-100">
      <input
        matInput
        type="datetime-local"
        [ngModel]="internalValue"
        (ngModelChange)="internalValueChanged($event)"
        #dateinput="ngModel"
        [placeholder]="control.caption | translate"
        [readonly]="control.isReadonly"
        [required]="control.required"
        (blur)="markTouch()"
        />
      @if (errorMessage) {
        <mat-error>{{ errorMessage.message | translate: errorMessage.params }}</mat-error>
      }
    </mat-form-field>
    `,
    styles: [
        `
           input {
             /* adjustments for material look */
             /* fix height */
             height: 1em;
             padding-top: 1em;
             /* placement */
             padding-bottom: 0.3em;
             margin-top: -0.3em;
             /* remove spacing */
             margin-bottom: -1em;
           }
         `,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateTimePickerComponent extends InputControlBase implements OnInit {
  protected internalValue: string;

  @ViewChild('dateinput') dateinput: NgModel;

  ngOnInit(): void {
    super.ngOnInit();

    this.subscription.add(
      this.control.valueChanges.pipe(startWith(this.control.value)).subscribe({
        next: controlValue => {
          this.internalValue = controlValue ? formatDate(new Date(controlValue), 'yyyy-MM-ddTHH:mm', 'en-US') : null;
        },
      })
    );

    this.subscription.add(
      this.control.touchStateChanged.subscribe({
        next: () => {
          this.dateinput.control.markAsTouched();
        },
      })
    );
  }

  protected internalValueChanged(change: string): void {
    this.control.setValue(change ? new Date(change).toISOString() : null);
    this.control.markAsDirty();
  }

  protected markTouch() {
    this.control.markAsTouched();
  }
}
